/**
 * 草稿 WS：incoming 有 updatedAt 且不早于缓存时采纳。
 * 入站无时间戳且缓存已有时间戳时拒绝覆盖，避免迟到空包冲掉发送后新连的边。
 */
export function shouldAdoptDraftByUpdatedAt(
  cachedUpdatedAt: string | null | undefined,
  incomingUpdatedAt: string | null | undefined
): boolean {
  if (!incomingUpdatedAt) return !cachedUpdatedAt;
  if (!cachedUpdatedAt) return true;
  return incomingUpdatedAt >= cachedUpdatedAt;
}
